import React from 'react';

import { BlanketInsuranceCreateDetails } from '@components/utilities/BlanketInsurance/BlanketInsuranceCreateDetails';
import { useSearch } from '@hooks/next/useSearch';
import { BlanketInsuranceActionStatus } from '@models/next/BlanketInsurance';
import { z } from 'zod';

export const BlanketInsuranceDetails: React.FC = () => {
  const { search } = useSearch(
    z.object({
      id: z.number(),
      action: BlanketInsuranceActionStatus.optional(),
    }),
  );

  return <BlanketInsuranceCreateDetails type="details" id={search.id} action={search.action} />;
};
